module.exports = __webpack_public_path__ + "img/bill3.0a3b77a9.png";